import {DtxSpacer} from "src/components/common/DtxSpacer";
import {ValidatedField} from "src/pages/AdminPage/AddAndUpdateSaas/dialogs/sharedFields/ValidatedField";

export const NameAndToken = () => {

  return <>
    <ValidatedField
      valueKey = 'name'
      placeholder= "Organization Name"
      errorLabel = "Organization Name required"
    />
    <DtxSpacer space={2} />
    <ValidatedField
      valueKey = 'token'
      placeholder= "Token"
      errorLabel = "Token Required"
    />
  </>;
};
